import React, { useEffect, useRef, useState } from "react";
import { useConfigContext } from "../../config/ConfigProvider";
import { Languages } from "../../Constants";
import "./LocalizationSwitcher.scss";

const LocalizationSwitcher = ({ changeLang }) => {
  const ref = useRef();
  const { culture, changeCulture } = useConfigContext();

  const [cultureMenu, setCultureMenu] = useState(false);

  useEffect(() => {
    const handler = (event) => {
      const target = event.target;
      if (cultureMenu && ref.current && !ref.current.contains(target)) {
        setCultureMenu(false);
      }
    };

    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, [cultureMenu]);

  const onChangeCulture = (culture) => {
    setCultureMenu(false);
    changeCulture(culture);
    if (changeLang) {
      changeLang();
    }
  };

  return (
    <div className={"localization-switcher"} ref={ref}>
      <div
        className={"localization-switcher-link"}
        onClick={() => setCultureMenu(!cultureMenu)}
      >
        <span className="language-icon">language</span>
        <span>{culture}</span>
      </div>
      <div
        className={`${"localization-switcher-dropdown"} ${
          cultureMenu && "show"
        }`}
      >
        <ul className={"localization-switcher-dropdown-list"}>
          {Languages?.map((culture) => (
            <li
              key={culture.name}
              onClick={() => onChangeCulture(culture.id)}
              className={`${"localization-switcher-dropdown-list-item"} ${
                culture.id === culture ? "active" : ""
              }`}
            >
              <span className={"name"}>{culture.name}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default LocalizationSwitcher;
